/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input, ViewChild} from '@angular/core';

import {Location} from "../../models/location";
import {LocationInstance} from "../../models/location-instance";
import { LocationService } from "../../services/location.service";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from '../simple-success-error-dialog-box/simple-success-error-dialog-box.component';

declare var $: any;

@Component({
  selector: 'app-create-site-dialog',
  templateUrl: './create-site-dialog.component.html'
})
export class CreateSiteDialogComponent {

  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;
  
  @Output()
  createdLocation = new EventEmitter<LocationInstance>();
  
  @Input()
  locationTypes: Location[];
  
  mLocationName: string = null;
  mLocationType: Location = null;
  
  
  constructor(
    private mLocationService: LocationService
  ) { }
  
  
  show(): void {
    console.log("show()");
    this.mLocationName = null;
    this.mLocationType = this.locationTypes == null || this.locationTypes.length == 0? null : this.locationTypes[0];
    $("#createSiteDialog").modal("show");
  }
  
  hide(): void {
    console.log("hide()");
    $("#createSiteDialog").modal("hide");
  }
  
  
  createSiteClicked(): void {
    console.log("createSiteClicked() - Name: " + this.mLocationName + ", Type: " + (this.mLocationType == null? "*NULL*" : this.mLocationType.name));
    if (this.mLocationName != null && this.mLocationName.length > 0 && this.mLocationType != null) {
      //Attempt to create the new Location Instance with the above information...
      const newLocation = new LocationInstance();
      newLocation.name = this.mLocationName;
      newLocation.location = this.mLocationType;
      
      this.mLocationService
        .createLocationInstance(newLocation)
        .then(
          success => {
            this.createdLocation.emit(success);
            this.hide();
          },
          error => this.handleError(error)
        );
    }
  }
  
  
  handleError(error: any): void {
    console.error("handleError() - " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }
  
}
